<p-panel
  [styleClass]="'panel-shadow'"
  [class.ghost]="!recognitionTask"
  [style]="{ 'margin-bottom': '1em' }"
>
  <p-header>
    <div class="panel-header">Recognition Status</div>
  </p-header>
  <div class="">
    <div class="grid-label-value">
      <div>Status:</div>
      <div class="ghost-fill value">{{ recognitionTask?.regStatusName }}</div>
    </div>

    <div class="text-right mt-2">
      <button
        pButton
        (click)="setRegStatusToManualUpdate()"
        label="Set to 'Manually Updated'"
        class="ui-button ui-button-secondary mb-2 btn-mobile-block"
        pTooltip="Change Verification Status to 'Manually Updated'"
      ></button>
      <button
        pButton
        (click)="editRegStatus(recognitionTask)"
        label="Change"
        class="ui-button ui-button-secondary mb-2 ml-2 btn-mobile-block"
      ></button>
    </div>
  </div>
</p-panel>

<p-dialog
  header="Edit Reg Status"
  [(visible)]="showEditRegStatusDialog"
  [responsive]="true"
  blockScroll="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div>
    <div class="style2023 pt-3 pb-3">
      <div class="input-group flex w-100">
        <div class="input-group-prepend group-label">Status</div>
        <div class="input-group-item flex-grow-1">
          <p-dropdown
            name="regStatuses"
            [options]="regStatuses"
            placeholder="Select status"
            [style]="{ width: '100%' }"
            [(ngModel)]="regStatusId"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </div>
  <p-footer class="rounded-bottom-border">
    <div class="text-right">
      <button
        type="button"
        pButton
        label="Close"
        class="mr-2 ui-button-tertiary"
        (click)="showEditRegStatusDialog = false"
      ></button>
      <button
        type="button"
        class="ui-button-primary"
        pButton
        (click)="saveRegStatus()"
        label="Save"
        [disabled]="!regStatusId"
      ></button>
    </div>
  </p-footer>
</p-dialog>
